module.exports = __webpack_public_path__ + "img/SPX2.a837ec34.png";